import { render, staticRenderFns } from "./owners.vue?vue&type=template&id=13b1e83c&"
import script from "./owners.vue?vue&type=script&lang=ts&"
export * from "./owners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports